import React from 'react'
import { Dialog, DialogTitle, DialogContent, DialogActions, MenuItem, Select, TextField } from '@mui/material'
import { MButton } from 'components'

interface UpdateCognitoDialogProps {
  open: boolean
  onClose: () => void
  onUpdate: (selected: string, value: string) => void
  accountValues: Record<string, string>
}

const options = [
  { label: 'CCS-CSR- Impersonation - Account ID', value: 'custom:defaultAccountId' },
  { label: 'MyHUB Customer Registered Account ID', value: 'custom:escID' },
  { label: 'Payment Vendor - Customer Account ID', value: 'custom:icID' }
]

export const UpdateCognitoDialog: React.FC<UpdateCognitoDialogProps> = ({
  open,
  onClose,
  onUpdate,
  accountValues
}) => {
  const [selected, setSelected] = React.useState(options[0])
  const [value, setValue] = React.useState('')

  React.useEffect((): void => {
    if (selected && accountValues) {
      setValue(accountValues[selected.value] || '')
    }
  }, [selected, accountValues])

  const handleUpdate = (): void => {
    onUpdate(selected.value, value)
  }

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Update AWS Cognito</DialogTitle>
      <DialogContent sx={{ padding: 2 }}>
        <Select
          fullWidth
          value={selected.value}
          onChange={(e): void => {
            const found = options.find(opt => opt.value === e.target.value)
            if (found) setSelected(found)
          }}
          sx={{ mb: 2 }}
        >
          {options.map(item => (
            <MenuItem key={item.value} value={item.value}>
              {item.label}
            </MenuItem>
          ))}
        </Select>
        <TextField
          fullWidth
          label='Account ID'
          value={value}
          inputProps={{ maxLength: 10, inputMode: 'numeric', pattern: '[0-9]*' }}
          onChange={(e) => {
            const newValue = e.target.value.replace(/[^0-9]/g, '')
            setValue(newValue)
          }}
        />

        <DialogActions sx={{ mt: 0.5 }}>
          <MButton onClick={handleUpdate} variant='contained' rounded='true'>
            Update
          </MButton>
          <MButton onClick={onClose} variant='outlined' rounded='true'>
            Cancel
          </MButton>
        </DialogActions>
      </DialogContent>

    </Dialog>
  )
}
